import { Controller } from "@hotwired/stimulus"
import { debounce } from "../application"

// Suggests help articles in a Turbo Frame while someone writes to support,
// so a question an article already answers can be solved before it is sent.
export default class extends Controller {
  static targets = ["frame"]

  static values = {
    url: String,
    minLength: { type: Number, default: 12 }
  }

  connect() {
    this.debouncedSuggest = debounce((message) => this.suggest(message), 400)
  }

  update(event) {
    this.debouncedSuggest(event.target.value.trim())
  }

  suggest(message) {
    if (message.length < this.minLengthValue) {
      this.frameTarget.removeAttribute("src")
      this.frameTarget.innerHTML = ""
      return
    }

    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set("q", message)
    this.frameTarget.src = url.toString()
  }
}
